var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoXmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3291 0.670919C22.8994 0.24133 22.3166 0 21.709 0C21.1014 0 20.5186 0.24133 20.0889 0.670919L11.9862 8.77366L3.88343 0.670919C3.45125 0.253505 2.87241 0.0225345 2.27159 0.0277555C1.67076 0.0329765 1.09603 0.273971 0.671165 0.698833C0.246302 1.1237 0.00530815 1.69843 8.7738e-05 2.29926C-0.00513268 2.90008 0.225836 3.47892 0.643251 3.9111L8.74599 12.0138L0.643251 20.1166C0.225836 20.5488 -0.00513268 21.1276 8.7738e-05 21.7284C0.00530815 22.3292 0.246302 22.904 0.671165 23.3288C1.09603 23.7537 1.67076 23.9947 2.27159 23.9999C2.87241 24.0051 3.45125 23.7742 3.88343 23.3567L11.9862 15.254L20.0889 23.3567C20.5211 23.7742 21.0999 24.0051 21.7007 23.9999C22.3016 23.9947 22.8763 23.7537 23.3012 23.3288C23.726 22.904 23.967 22.3292 23.9722 21.7284C23.9775 21.1276 23.7465 20.5488 23.3291 20.1166L15.2263 12.0138L23.3291 3.9111C23.7587 3.48138 24 2.89863 24 2.29101C24 1.68339 23.7587 1.10064 23.3291 0.670919Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoXmark);
export default __webpack_public_path__ + "static/media/ico-xmark.97b034d7f672c29d7a3cb42b3cbbc0be.svg";
export { ForwardRef as ReactComponent };